import { Modal } from 'antd'

type PreviewImgProps = {
  visible: boolean
  title: string
  onCancel: () => void
  src: string
}

export function PreviewImg(props: PreviewImgProps) {
  const { visible, title, onCancel, src } = props
  return (
    <Modal visible={visible} title={title} footer={null} onCancel={onCancel}>
      <img alt='example' style={{ width: '100%' }} src={src} />
    </Modal>
  )
}
